// extracted by css-extract-rspack-plugin
export default {"wrapper":"N58nL","formatting":"uCewl","prefix":"_UJLS","error":"LDrpu","editor":"QauBx","tooltips":"FDe7C"};